import { render } from "./home.vue?vue&type=template&id=24573e49"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script